function init(el) {
    const url = el.dataset.url || window.location.href;
    const title = el.dataset.title || document.title;

    const triggerBtn = el.querySelector('[data-ref="triggerBtn"]');

    triggerBtn?.addEventListener('click', (e) => {
        e.preventDefault();

        if (typeof navigator.share === 'function') {
            navigator.share({ url, title }).catch((err) => {
                if (err?.name !== 'AbortError') console.error('Share failure:', err);
            });
        }
    });
}

// Init all share lists on the page
document.querySelectorAll('[data-share-list]').forEach(init);
